(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gofar-purchase-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gofar-purchase-controls')) {
    customElements.define('gofar-purchase-controls', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-info');
        this.form = this.root?.querySelector('product-form form');
        if (!this.form) return;
        this.sizeChosen = this.dataset.directVariant === 'true' && !new URLSearchParams(location.search).has('gofar_choose_size');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal, capture: true };
        this.root.addEventListener('change', (event) => {
          if (event.target.closest('[data-gofar-size-option]')) {
            this.sizeChosen = true;
            this.sizeField?.removeAttribute('data-choice-needed');
          }
        }, options);
        this.form.addEventListener('submit', (event) => {
          if (this.needsSize) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.requestSize();
          }
        }, options);
        this.bar = this.querySelector('[data-sticky-atc]');
        this.trigger = this.querySelector('[data-sticky-atc-trigger]');
        this.trigger?.addEventListener('click', () => {
          if (this.needsSize) this.requestSize();
          else this.mainButton?.click();
        }, { signal: this.abort.signal });
        this.observer = new MutationObserver((records) => {
          if (records.some(record => !this.contains(record.target))) this.sync();
        });
        this.observer.observe(this.root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
        if (this.bar && this.mainButton) {
          this.bar.hidden = false;
          document.body.classList.add('has-sticky-atc');
          this.intersection = new IntersectionObserver(([entry]) => {
            this.bar.dataset.visible = String(!entry.isIntersecting);
            this.bar.inert = entry.isIntersecting;
          }, { rootMargin: '-80px 0px 0px', threshold: 0 });
          this.intersection.observe(this.mainButton);
        }
        this.sync();
      }
      get sizeField() { return this.root?.querySelector('[data-gofar-size-option]'); }
      get needsSize() { return !!this.sizeField && !this.sizeChosen; }
      get mainButton() { return this.form?.querySelector('[name="add"]'); }
      requestSize() {
        const field = this.sizeField;
        if (!field) return;
        field.setAttribute('data-choice-needed', '');
        field.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        field.querySelector('input, select')?.focus({ preventScroll: true });
      }
      sync() {
        if (this.needsSize) {
          this.sizeField.querySelectorAll('input[type="radio"]:checked').forEach(input => { input.checked = false; });
        }
        const prompt = this.root.querySelector('[data-gofar-size-prompt]');
        const soldOut = this.dataset.productAvailable === 'false';
        if (prompt) prompt.hidden = !this.needsSize || soldOut;
        if (!this.bar) return;
        const unavailable = this.mainButton?.disabled || this.mainButton?.getAttribute('aria-disabled') === 'true';
        this.trigger.disabled = soldOut || (!this.needsSize && !!unavailable);
        const label = soldOut ? this.dataset.soldLabel : this.needsSize ? this.dataset.chooseLabel : (this.mainButton?.querySelector('span')?.textContent.trim() || this.dataset.addLabel);
        if (this.trigger.textContent !== label) this.trigger.textContent = label;
        const selected = [...this.root.querySelectorAll('variant-selects input:checked, variant-selects select option:checked')].map(input => input.value).join(' · ');
        const selection = this.querySelector('[data-sticky-selection]');
        const selectionText = soldOut ? selected : this.needsSize ? [selected, this.dataset.chooseLabel].filter(Boolean).join(' · ') : selected;
        if (selectionText && selection.textContent !== selectionText) selection.textContent = selectionText;
        const price = this.root.querySelector('[id^="price-"] .price-item--sale')?.closest('.price--on-sale')?.querySelector('.price-item--sale') || this.root.querySelector('[id^="price-"] .price-item--regular');
        const target = this.querySelector('[data-sticky-price]');
        if (price && target.textContent !== price.textContent.trim()) target.textContent = price.textContent.trim();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.intersection?.disconnect();
        document.body.classList.remove('has-sticky-atc');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
